/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconApiApp = createReactComponent("outline", "api-app", "IconApiApp", [["path", { "d": "M12 15h-6.5a2.5 2.5 0 1 1 0 -5h.5", "key": "svg-0" }], ["path", { "d": "M15 12v6.5a2.5 2.5 0 1 1 -5 0v-.5", "key": "svg-1" }], ["path", { "d": "M12 9h6.5a2.5 2.5 0 1 1 0 5h-.5", "key": "svg-2" }], ["path", { "d": "M9 12v-6.5a2.5 2.5 0 0 1 5 0v.5", "key": "svg-3" }]]);

export { IconApiApp as default };
//# sourceMappingURL=IconApiApp.mjs.map
